<template>
  <h1>Adios</h1>
</template>

<script>
  export default {
    name: 'PagesLogout',
    created () {
      this.logout()
    },
    methods: {
      logout () {
        this.$store.dispatch('destroyToken').then(response => {
          this.$router.push({ name: 'login' })
        })
      },
    },
  }
</script>
